__turbopack_context__.v({
  "className": "sailecfont_af31a7c4-module__6TP0ra__className",
  "variable": "sailecfont_af31a7c4-module__6TP0ra__variable",
});
